"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initLogger = void 0;
const pino_1 = __importDefault(require("pino"));
/**
 * initilizes logger for every service
 * @param config additional configuration such as service name
 * @param logLevel default log level to be used
 * @returns Logger class which can be used for logging
 */
const initLogger = (config, logLevel) => (0, pino_1.default)().child(config, { level: logLevel });
exports.initLogger = initLogger;
